export default class StocksGestionRapportActiviteSyntheseController {
	static $inject = [
		'$scope',
		'$state',
		'$uibModal',
		'notification',
		'$translate',
		'$filter',
		'moment',
		'StocksGestionRapportActiviteService',
		'StocksService',
		'MassiaRightsService',
		'$location',
		'localStorageService'
	];

	constructor(
		$scope,
		$state,
		$uibModal,
		notification,
		$translate,
		$filter,
		moment,
		StocksGestionRapportActiviteService,
		StocksService,
		MassiaRightsService,
		$location,
		localStorageService
	) {
		this.$scope = $scope;
		this.$state = $state;
		this.$uibModal = $uibModal;
		this.notification = notification;
		this.$translate = $translate;
		this.$filter = $filter;
		this.moment = moment;
		this.StocksGestionRapportActiviteService = StocksGestionRapportActiviteService;
		this.StocksService = StocksService;
		this.MassiaRightsService = MassiaRightsService;
		this.$location = $location;
		this.localStorageService = localStorageService;
		this.isEdit = false;
		this.loading = false;
		this.societes = [];
		this.sites = [];
		this.eltsNiv1 = [];
		this.gestionRapportLignes = [];
	}

	async $onInit() {
		this.color = '#ccccccc';
		this.colorGreen = '#e6ffe6';
		this.colorDarkGreen = '#ccffcc';
		this.arrondi = 3;

		await this.loadSocietes();
		const societeId = this.localStorageService.get('STOCK_RAPPORT_ACTIVITES_SYNTH_SOCIETE_ID');
		if (this.societes.length > 0) {
			this.idSociete = societeId || this.societes[0].id;
			if (this.idSociete) {
				await this.loadSites();
				const grpSiteId = this.localStorageService.get('STOCK_RAPPORT_ACTIVITES_SYNTH_GRPSITE_ID');
				if (this.sites.length > 0) {
					this.idSite = grpSiteId || this.sites[0].id;
					if (this.idSite) {
						await this.getEltsNiv1(this.idSite);
					}
				}
			}
		}

		this.$scope.$watch('$ctrl.idSociete', async (newValue, oldValue) => {
			if (newValue !== oldValue) {
				this.localStorageService.set('STOCK_RAPPORT_ACTIVITES_SYNTH_SOCIETE_ID', newValue);
				this.eltsNiv1 = [];
				await this.loadSites();
				if (this.sites.length > 0) {
					this.idSite = this.sites[0].id;
				}
			}
		});
		this.$scope.$watch('$ctrl.idSite', async (newValue, oldValue) => {
			if (newValue !== oldValue) {
				this.localStorageService.set('STOCK_RAPPORT_ACTIVITES_SYNTH_GRPSITE_ID', newValue);
				this.eltsNiv1 = [];
				await this.getEltsNiv1(newValue);
				this.gestionRapportLignes = [];
			}
		});
	}

	async loadSocietes() {
		this.startLoading();
		try {
			this.societes = await this.StocksGestionRapportActiviteService.getSocietes();
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async loadSites() {
		this.startLoading();
		try {
			this.sites = await this.StocksGestionRapportActiviteService.getSites(this.idSociete);
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async getEltsNiv1(idGroupeSite) {
		if (!idGroupeSite) return;
		this.startLoading();
		try {
			this.eltsNiv1 = await this.StocksService.getElementsNiv1(idGroupeSite);
			if (this.eltsNiv1.length > 0) {
				const mainEltNiv1Id = this.eltsNiv1.find((elt) => elt.isMain) || null;
				this.eltNiv1 = mainEltNiv1Id != null ? mainEltNiv1Id.code : this.eltsNiv1[0].code;
			}
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async getGestionRapport() {
		this.startLoading();

		this.gestionRapportLignes = [];

		if (!this.idSite || !this.eltNiv1 || !this.dateDebut || (!this.isEdit && !this.dateFin)) {
			this.stopLoading();
			this.notification.error('Filtre(s) manquant(s)');
			return;
		}

		try {
			this.gestionRapportLignes = await this.StocksGestionRapportActiviteService.getGestionRapportSynthese(
				this.idSite,
				this.eltNiv1,
				this.dateDebut,
				this.dateFin
			);
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async export() {
		if (!this.idSite || !this.eltNiv1 || !this.dateDebut || (!this.isEdit && !this.dateFin)) {
			this.stopLoading();
			this.notification.error('Filtre(s) manquant(s)');
			return;
		}

		this.startLoading();
		try {
			const fileData = await this.StocksGestionRapportActiviteService.exportSynthese(this.idSite, this.eltNiv1, this.dateDebut, this.dateFin);
			if (fileData) {
				const fileName = 'RapportActivitesSynthese.xlsx';
				const blob = new Blob([fileData.data], { type: fileData.headers()['content-type'] + ';charset=UTF-8' });
				const link = document.createElement('a');
				link.href = URL.createObjectURL(blob);
				link.download = fileName;

				link.dispatchEvent(
					new MouseEvent('click', {
						view: window,
						bubbles: true,
						cancelable: false
					})
				);
			}
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}
}
